// src/pages/TransactionEntry/useTransactionRows.js
import { useState } from "react";

const makeEmptyRow = (id) => {
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(
    now.getDate()
  ).padStart(2, "0")}`;
  return {
    id,
    accountId: "",
    date: today,
    expenseType: "",
    description: "",
    amountIn: "",
    amountOut: "",
    paidBy: "",
    comment: "",
    proofFile: null,
    error: null,
  };
};

export default function useTransactionRows() {
  const [rows, setRows] = useState([makeEmptyRow(1)]);
  const [nextId, setNextId] = useState(2);

  const addRow = () => {
    setRows((prev) => [...prev, makeEmptyRow(nextId)]);
    setNextId((id) => id + 1);
  };

  const updateRow = (id, field, value) => {
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, [field]: value } : row))
    );
  };

  const setRowError = (id, error) => {
    setRows((prev) =>
      prev.map((row) => (row.id === id ? { ...row, error } : row))
    );
  };

  const removeRow = (id) => {
    setRows((prev) => prev.filter((row) => row.id !== id));
  };

  // Used by Excel import only. It replaces the on-screen entry rows;
  // it does NOT save anything to Firestore.
  const replaceRows = (incomingRows) => {
    const safeRows = Array.isArray(incomingRows) ? incomingRows : [];

    if (safeRows.length === 0) {
      setRows([makeEmptyRow(1)]);
      setNextId(2);
      return;
    }

    const numberedRows = safeRows.map((row, index) => ({
      ...makeEmptyRow(index + 1),
      ...row,
      id: index + 1,
      proofFile: row?.proofFile || null,
      error: row?.error || null,
    }));

    setRows(numberedRows);
    setNextId(numberedRows.length + 1);
  };

  const resetRows = () => {
    setRows([makeEmptyRow(1)]);
    setNextId(2);
  };

  return {
    rows,
    addRow,
    updateRow,
    removeRow,
    setRowError,
    replaceRows,
    resetRows,
  };
}
